import { useServices } from 'containers/services';
import { useAppNotifications } from 'hooks';
import type { CreateMeterModuleArg, CreateMeterModuleResult } from 'lib/services';
import { useMutation, type UseMutationResult, useQueryClient } from 'react-query';
import { getErrorMessage } from 'utils/getErrorMessage';
import { MUTATION_KEYS, QUERY_KEYS } from 'utils/queryKeys';

export const useCreateMeterModule = (): UseMutationResult<CreateMeterModuleResult, unknown, CreateMeterModuleArg> => {
  const queryClient = useQueryClient();
  const { meterModulesApiClient } = useServices();
  const notify = useAppNotifications();

  return useMutation({
    mutationKey: MUTATION_KEYS.meterModules.create(),
    mutationFn: async (arg: CreateMeterModuleArg) => await meterModulesApiClient.create(arg),
    onError: error => {
      notify.error({
        message: 'There was an error while creating meter module',
        description: getErrorMessage(error),
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries(QUERY_KEYS.meterModules.all());
      notify.success({
        message: `Meter module created`,
      });
    },
  });
};
